export default __webpack_public_path__ + "static/media/alarm.redflag.ce5324c4.mp3";